import { useState, useRef, useEffect } from "react";
import { db, auth } from "./firebase";
import {
  collection, doc, setDoc, deleteDoc, updateDoc,
  onSnapshot, getDocs
} from "firebase/firestore";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";

// ─── Colores ──────────────────────────────────────────────────────────────────
const GOLD="#C6FF00",GOLD2="#DFFF66",DARK="#0a0a0a",DARK2="#111111",DARK3="#1a1a1a",DARK4="#222222",BORDER="#2a2a2a",WHITE="#F5F1E8",MUTED="#888888",MUTED2="#555555",GREEN="#4ade80",RED="#ef4444";
const ADMIN_EMAIL="balicia.blc@gmail.com"; // Debe coincidir EXACTO con el usuario creado en Firebase → Authentication
const ADMIN_PIN="000000";
const TITULAR="Mia Arisleidy San Juan"; // ⚠️ Si la cuenta bancaria está a nombre de otra persona, cambia esto por ese nombre
const TOTAL_BOLETOS=10000;
const LOTERIAS_POR_DIGITOS={
  3:[{id:"toca3",label:"Toca 3 (Loteka)",horario:"7:55 p.m."}],
  4:[{id:"pega4",label:"Pega 4 (Lotería Real)",horario:"12:55 p.m."}],
  5:[
    {id:"pick5_dia",label:"Pick 5 Florida (Día)",horario:"1:30 p.m."},
    {id:"pick5_noche",label:"Pick 5 Florida (Noche)",horario:"9:45 p.m."},
  ],
};
const totalBoletosRifa=(rifa)=>Math.pow(10,rifa?.digitos||4);
const loteriaDeRifa=(rifa)=>{
  const opciones=LOTERIAS_POR_DIGITOS[rifa?.digitos||4]||LOTERIAS_POR_DIGITOS[4];
  return opciones.find(o=>o.id===rifa?.loteria)||opciones[0];
};
const CODIGO_ELIMINAR="ELIMINAR123";
const ADMIN_WHATSAPP="18299177634"; // Número real de contacto de la página
const CANAL_WHATSAPP="https://whatsapp.com/channel/TU_CANAL_AQUI"; // ⚠️ Pon aquí tu canal de WhatsApp si conservas uno, o quita este bloque si no tienes

const enviarWhatsApp=(telefono, mensaje)=>{
  const num=telefono.replace(/\D/g,"");
  const url=`https://wa.me/${num}?text=${encodeURIComponent(mensaje)}`;
  window.open(url,"_blank");
};

const PAQUETES=[
  {n:5,label:"🍀 Suertudo"},
  {n:10,label:"🙏 Bendecido"},
  {n:15,label:"✨ Premium"},
  {n:20,label:"👑 VIP Ganador"},
];

const CUENTAS_DEFAULT=[
  {banco:"Banco Popular",cuenta:"CAMBIA-ESTE-NUMERO",icon:"🏦"},
  {banco:"BanReservas",cuenta:"CAMBIA-ESTE-NUMERO",icon:"🏛️"},
];
// ⚠️ Estas cuentas también se pueden editar luego desde el panel admin (sección "Cuentas"), sin tocar código.

const exportarBoletos = async () => {
  const snapshot = await getDocs(collection(db, "boletos"));
  let csv = "Comprador,Telefono,Numeros,Cantidad,Precio,Estado,Fecha,RifaID,Referido\n";
  snapshot.forEach((docu) => {
    const b = docu.data();
    const nombre = b.comprador?.nombre || b.comprador || "";
    const telefono = b.comprador?.telefono || b.telefono || "";
    const numeros = Array.isArray(b.numeros) ? b.numeros.join(" - ") : b.numeros || "";
    const fecha = b.creadoEn?.toDate ? b.creadoEn.toDate().toLocaleString("es-DO") : "";
    csv += `"${nombre}","${telefono}","${numeros}",${b.cantidad || ""},${b.precio || ""},"${b.estado || ""}","${fecha}","${b.rifaId || ""}","${b.referido || ""}"\n`;
  });
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `boletos_winnersrd_${new Date().toISOString().slice(0,10)}.csv`;
  link.click();
};
const RIFA_DEFAULT=()=>({
  id:`rifa_${Date.now()}`,
  nombre:"Nueva Rifa",
  premio:"",
  precio:100,
  minBoletos:2,
  activa:true,
  imagen:"",
});

const fmt=(n,digitos=4)=>String(n).padStart(digitos,"0");
const TABS=["Participar","Boletos","FAQ"];

const FAQS=[
  {q:"¿Cómo funciona el sorteo?",a:"Cada número tiene una combinación única de 3 dígitos (000-999). Si tu número coincide exactamente con el resultado del Toca 3 del día del sorteo, ¡ganas el premio!"},
  {q:"¿Cuándo recibo mi número?",a:"Tu número se asigna automáticamente una vez que verificamos tu pago. Te lo enviamos por WhatsApp junto con la confirmación."},
  {q:"¿Cómo sé que el sorteo es real?",a:"Tomamos como referencia el resultado del Toca 3 de Lotería Loteka, que es público y verificable por cualquier persona. Además publicamos el resultado en nuestras redes."},
  {q:"¿Cuándo se realiza el sorteo?",a:"El sorteo se efectuará cuando se hayan vendido el 100% de los números disponibles. La fecha se anunciará oficialmente en ese momento."},
  {q:"¿Cómo contactan al ganador?",a:"El ganador es contactado por el WhatsApp registrado durante la compra. Por eso es importante escribirlo correctamente."},
  {q:"¿Qué pasa si escribo mal mis datos?",a:"Es responsabilidad del participante verificar sus datos antes de enviar el comprobante. Asegúrate de escribir bien tu nombre y WhatsApp."},
];

const TERMINOS=`TÉRMINOS Y CONDICIONES — WinnersRD

Bienvenido a WinnersRD, plataforma de rifas y sorteos operada bajo las leyes de la República Dominicana. Al participar, usted acepta los siguientes términos en su totalidad.

1. NATURALEZA DEL SERVICIO
WinnersRD es una plataforma digital de rifas donde los participantes adquieren boletos numerados para optar por premios en efectivo u objetos de valor. La participación es completamente voluntaria y está sujeta a disponibilidad de boletos.

2. REQUISITOS DE PARTICIPACIÓN
• Tener 18 años o más
• Proporcionar nombre completo y número de WhatsApp válidos
• Realizar el pago por los métodos habilitados en la plataforma
• Adjuntar comprobante de pago válido y legible

3. COMPRA DE BOLETOS
• La compra mínima de boletos puede variar según el precio establecido para cada rifa
• El pago debe realizarse mediante transferencia bancaria al instante — no se aceptan transferencias diferidas ni pagos programados
• Los números se asignan de forma aleatoria y automática por el sistema únicamente después de que el pago haya sido verificado y aprobado
• Los números asignados no pueden cambiarse ni elegirse manualmente
• Toda compra queda en estado pendiente hasta que WinnersRD valide el comprobante
• La validación se realiza en un máximo de 24 horas hábiles

4. VALIDACIÓN Y APROBACIÓN
WinnersRD se reserva el derecho de aprobar o rechazar cualquier compra si el comprobante presenta irregularidades, es ilegible o no corresponde al monto indicado. Los boletos rechazados quedan disponibles para otros participantes. El participante será notificado vía WhatsApp.

5. SORTEOS
• El sorteo se realiza cuando se haya vendido el 100% de los boletos disponibles
• Se toma como referencia el resultado público del Toca 3 de Lotería Loteka de la fecha anunciada. WinnersRD no está afiliada ni respaldada por Lotería Loteka
• Todos los sorteos se transmiten en vivo por Instagram para garantizar total transparencia
• WinnersRD puede posponer el sorteo por causa de fuerza mayor, notificando a todos los participantes

6. TOP 3 COMPRADORES
Se reconocerá públicamente a los 3 participantes con mayor cantidad de boletos confirmados. En caso de empate, tendrá prioridad quien haya realizado su compra primero según fecha y hora registrada en el sistema. Comprar un boleto adicional es suficiente para superar un empate.

7. ENTREGA DE PREMIOS
• El ganador será contactado al WhatsApp registrado en su compra
• Deberá presentar identificación válida (cédula dominicana o pasaporte) para reclamar el premio
• Los premios se entregan en República Dominicana. Gastos de traslado corren por cuenta del ganador salvo indicación contraria
• El ganador tiene 30 días calendario desde el sorteo para reclamar su premio

8. POLÍTICA DE REEMBOLSO
No se realizan reembolsos una vez aprobada la compra y asignados los boletos. Si la compra es rechazada por comprobante inválido, el participante debe gestionar con su entidad financiera ya que el dinero no fue acreditado a WinnersRD.

9. POLÍTICA ANTI-FRAUDE
WinnersRD bloqueará permanentemente cualquier número de WhatsApp que:
• Envíe comprobantes falsos o manipulados
• Intente manipular el sistema o realizar fraude
• Viole cualquiera de estos términos
Lo anterior puede derivar en acciones legales conforme a las leyes dominicanas.

10. PROPIEDAD INTELECTUAL
Todo el contenido de esta plataforma — diseño, textos, logotipos y código — es propiedad de WinnersRD y está protegido por las leyes de propiedad intelectual de la República Dominicana. Queda prohibida su reproducción sin autorización.

11. LIMITACIÓN DE RESPONSABILIDAD
WinnersRD no se responsabiliza por interrupciones técnicas ajenas a la plataforma, ni por errores del participante al ingresar sus datos personales o de pago.

12. MODIFICACIONES
Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos desde su publicación. El uso continuo de la plataforma implica aceptación.

13. LEY APLICABLE
Estos términos se rigen por las leyes de la República Dominicana. Cualquier controversia será sometida a los tribunales competentes del Distrito Nacional.

14. CONTACTO
Para consultas, contáctenos vía WhatsApp o nuestras redes sociales oficiales @winnersrd.`;

const BASES_DEFAULT=`BASES DE LA RIFA — "GÁNATE TU ESTACIÓN DE UÑAS"

1. PREMIO
Una estación de uñas lista para trabajar, compuesta por: capacitación profesional, mesa de manicure, drill/pulidora, posa manos, lámpara UV/LED, 2 sillas (para clienta y técnica), esterilizador, y set de esmaltes y limas. Las marcas y modelos específicos serán seleccionados por WinnersRD, garantizando calidad apta para uso profesional. El premio no es canjeable por dinero en efectivo, ni total ni parcialmente.

2. MECÁNICA DE PARTICIPACIÓN
Se emiten 1,000 números con combinaciones únicas de 3 dígitos (000-999), a RD$100 cada uno, con compra mínima de 2 números, exclusivamente a través de winnersrd-54d50.web.app. Los números se asignan una vez verificado el pago y se notifican por WhatsApp. Participan únicamente mayores de 18 años residentes en la República Dominicana.

3. SORTEO
El sorteo se efectuará una vez vendido el 100% de los números. La fecha exacta será anunciada con un mínimo de 3 días de antelación en la web y las redes oficiales de WinnersRD. Para determinar al ganador, WinnersRD toma como referencia el resultado público del sorteo del Toca 3 de Lotería Loteka correspondiente a la fecha y horario anunciados (7:55 p.m.). WinnersRD no interviene ni puede intervenir en dicho resultado, y no está afiliada, patrocinada ni respaldada por Lotería Loteka de ninguna forma. Siempre habrá un ganador, ya que la totalidad de las combinaciones estará vendida. El resultado podrá verificarse en el verificador público de winnersrd-54d50.web.app.

4. ENTREGA DEL PREMIO
El ganador será contactado por WhatsApp dentro de las 48 horas siguientes al sorteo y deberá validar su identidad con su cédula. La entrega se realizará en Higüey, La Altagracia. Si el ganador reside en otra ciudad, el costo y la coordinación del envío corren por su cuenta.

5. AVISO LEGAL
Esta promoción es organizada de forma independiente por WinnersRD y no está patrocinada, avalada ni administrada por Meta Platforms, Inc., ni asociada a Instagram, Facebook o WhatsApp de ninguna forma. Estos canales se utilizan únicamente para difusión y atención al cliente. Al participar, el usuario exime de toda responsabilidad a Meta Platforms, Inc. y a Lotería Loteka. Solo mayores de 18 años residentes en República Dominicana pueden participar.

6. DERECHO DE IMAGEN
El ganador acepta que el proceso de entrega del premio sea documentado en fotografía y video, y publicado en las plataformas de WinnersRD con fines promocionales, sin compensación adicional.

7. DISPOSICIONES FINALES
La participación en esta rifa implica la aceptación íntegra de estas bases y de los Términos y Condiciones generales de WinnersRD. No podrán participar el organizador ni sus familiares directos.`;

// ─── Root ─────────────────────────────────────────────────────────────────────
export default function WinnersRD(){
  const [tab,setTab]=useState(0);
  const [rifas,setRifas]=useState([]);
  const [solicitudes,setSolicitudes]=useState([]);
  const [boletosConfirmados,setBoletosConfirmados]=useState([]);
  const [rifaSel,setRifaSel]=useState(0);
  const [cuentas,setCuentas]=useState(CUENTAS_DEFAULT);
  const [adminAuth,setAdminAuth]=useState(false);
  const [loading,setLoading]=useState(true);
  const [configGeneral,setConfigGeneral]=useState({mantenimiento:false,mostrarReferido:false});

  const isAdminRoute=window.location.pathname==="/gestionSRD01";

  useEffect(()=>{
    // Sincroniza adminAuth con la sesión REAL de Firebase (esto es lo que
    // protege de verdad la base de datos, no la contraseña por sí sola)
    const unsubAuth=onAuthStateChanged(auth,(user)=>{
      setAdminAuth(!!user);
    });
    return ()=>unsubAuth();
  },[]);

  useEffect(()=>{
    const unsubRifas=onSnapshot(collection(db,"rifas"),(snap)=>{
      // Si no hay rifas creadas, el catálogo simplemente se muestra vacío.
      // Ya NO se crea ninguna rifa automática — todas se crean a mano desde el panel.
      setRifas(snap.docs.map(d=>({id:d.id,...d.data()})));
      setLoading(false);
    });

    // 🔥 Cargar boletos confirmados
    const unsubBoletos=onSnapshot(collection(db,"boletos"),(snap)=>{
      setBoletosConfirmados(snap.docs.map(d=>({id:d.id,...d.data()})));
    });

    // 🔥 Cargar cuentas de banco
    const unsubCuentas=onSnapshot(doc(db,"config","cuentas"),(snap)=>{
      if(snap.exists()&&snap.data().lista){
        setCuentas(snap.data().lista);
      }else if(auth.currentUser){
        // Primera vez — guardar las default en Firebase (solo si hay sesión admin)
        setDoc(doc(db,"config","cuentas"),{lista:CUENTAS_DEFAULT});
      }
    });

    // 🔥 Cargar configuración general (mantenimiento, referido, etc.)
    const unsubGeneral=onSnapshot(doc(db,"config","general"),(snap)=>{
      if(snap.exists()){
        setConfigGeneral(snap.data());
      }else if(auth.currentUser){
        setDoc(doc(db,"config","general"),{mantenimiento:false,mostrarReferido:false});
      }
    });

    return ()=>{unsubRifas();unsubBoletos();unsubCuentas();unsubGeneral();};
  },[]);

  useEffect(()=>{
    // 🔥 Las solicitudes pendientes solo se pueden leer con sesión de admin
    // (así lo exigen las reglas de seguridad) — por eso este listener va
    // aparte y solo se activa cuando adminAuth es true.
    if(!adminAuth){
      setSolicitudes([]);
      return;
    }
    const unsubSolicitudes=onSnapshot(collection(db,"solicitudes"),(snap)=>{
      setSolicitudes(snap.docs.map(d=>({id:d.id,...d.data()})));
    });
    return ()=>unsubSolicitudes();
  },[adminAuth]);

  const toggleConfigGeneral=async(campo)=>{
    const nuevo={...configGeneral,[campo]:!configGeneral[campo]};
    setConfigGeneral(nuevo);
    await setDoc(doc(db,"config","general"),nuevo,{merge:true});
  };

  const rifasActivas=rifas.filter(r=>r.activa);
  const rifaActiva=rifas[rifaSel]||rifas[0];

  const updateRifa=async(id,ch)=>{
    await updateDoc(doc(db,"rifas",id),ch);
  };

  if(loading)return(
    <div style={{minHeight:"100vh",background:DARK,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:16}}>
      <div style={{width:44,height:44,borderRadius:"50%",border:`3px solid ${BORDER}`,borderTop:`3px solid ${GOLD}`,animation:"spin 0.8s linear infinite"}}/>
      <p style={{color:MUTED,fontSize:13}}>Cargando WinnersRD...</p>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  // ── Vista Admin ──
  if(isAdminRoute){
    return(
      <div style={{minHeight:"100vh",background:DARK,fontFamily:"'Georgia',serif",color:WHITE,overflowX:"hidden"}}>
        <div style={{position:"fixed",top:-200,left:"50%",transform:"translateX(-50%)",width:600,height:400,borderRadius:"50%",background:`radial-gradient(circle,${GOLD}15,transparent 70%)`,pointerEvents:"none",zIndex:0}}/>
        <header style={{padding:"0 16px",height:60,display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:`1px solid ${BORDER}`,background:`${DARK2}ee`,backdropFilter:"blur(12px)",position:"sticky",top:0,zIndex:20}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{width:36,height:36,borderRadius:"50%",background:`linear-gradient(135deg,${GOLD},${GOLD2})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,boxShadow:`0 0 12px ${GOLD}55`}}>🔐</div>
            <div>
              <div style={{fontSize:15,fontWeight:"bold",fontStyle:"italic"}}>Winners<span style={{color:GOLD}}>RD</span> <span style={{color:MUTED,fontSize:11}}>Admin</span></div>
              <div style={{fontSize:8,color:GOLD,letterSpacing:3}}>— PANEL PRIVADO —</div>
            </div>
          </div>
          <button onClick={()=>window.location.href="/"} style={{background:"none",border:`1px solid ${BORDER}`,color:MUTED,borderRadius:8,padding:"5px 12px",cursor:"pointer",fontSize:11,fontFamily:"inherit"}}>Ver página pública</button>
        </header>
        <main style={{padding:"16px",maxWidth:480,margin:"0 auto",position:"relative",zIndex:1}}>
          <TabAdmin rifas={rifas} solicitudes={solicitudes} boletosConfirmados={boletosConfirmados} cuentas={cuentas} setCuentas={setCuentas} adminAuth={adminAuth} setAdminAuth={setAdminAuth} updateRifa={updateRifa} configGeneral={configGeneral} toggleConfigGeneral={toggleConfigGeneral}/>
        </main>
      </div>
    );
  }

  // ── Modo mantenimiento (solo afecta la vista pública, el admin siempre entra) ──
  if(configGeneral.mantenimiento&&!isAdminRoute){
    return(
      <div style={{minHeight:"100vh",background:"#000",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",padding:24,textAlign:"center",fontFamily:"'Georgia',serif"}}>
        <div style={{fontSize:46,marginBottom:16}}>🎰</div>
        <h1 style={{color:GOLD,fontSize:20,fontStyle:"italic",margin:"0 0 10px"}}>Winners<span style={{color:WHITE}}>RD</span></h1>
        <p style={{color:MUTED,fontSize:13,maxWidth:300,lineHeight:1.7,margin:0}}>Estamos actualizando la plataforma.<br/>Vuelve pronto — ¡la suerte no se detiene! 🍀</p>
      </div>
    );
  }

  // ── Vista Pública ──
  return(
    <div style={{minHeight:"100vh",background:DARK,fontFamily:"'Georgia',serif",color:WHITE,overflowX:"hidden"}}>
      <div style={{position:"fixed",top:-200,left:"50%",transform:"translateX(-50%)",width:600,height:400,borderRadius:"50%",background:`radial-gradient(circle,${GOLD}15,transparent 70%)`,pointerEvents:"none",zIndex:0}}/>

      <header style={{padding:"0 16px",height:60,display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:`1px solid ${BORDER}`,background:`${DARK2}ee`,backdropFilter:"blur(12px)",position:"sticky",top:0,zIndex:20}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:36,height:36,borderRadius:"50%",background:`linear-gradient(135deg,${GOLD},${GOLD2})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,boxShadow:`0 0 12px ${GOLD}55`}}>🎟️</div>
          <div>
            <div style={{fontSize:15,fontWeight:"bold",fontStyle:"italic"}}>Winners<span style={{color:GOLD}}>RD</span></div>
            <div style={{fontSize:8,color:GOLD,letterSpacing:3}}>— OFICIAL —</div>
          </div>
        </div>
        <span style={{background:`${GOLD}22`,border:`1px solid ${GOLD}55`,borderRadius:99,padding:"3px 10px",fontSize:10,color:GOLD}}>
          {rifasActivas.length} sorteo{rifasActivas.length!==1?"s":""} activo{rifasActivas.length!==1?"s":""}
        </span>
      </header>

      <div style={{display:"flex",borderBottom:`1px solid ${BORDER}`,background:`${DARK2}f0`,position:"sticky",top:60,zIndex:19}}>
        {TABS.map((t,i)=>(
          <button key={t} onClick={()=>setTab(i)} style={{flex:1,padding:"12px 4px",background:"none",border:"none",color:tab===i?GOLD:MUTED2,fontSize:11,cursor:"pointer",borderBottom:`2px solid ${tab===i?GOLD:"transparent"}`,fontFamily:"inherit",transition:"all 0.2s"}}>{t}</button>
        ))}
      </div>

      {rifasActivas.length>1&&(
        <div style={{padding:"10px 16px",background:DARK2,borderBottom:`1px solid ${BORDER}`}}>
          <div style={{display:"flex",gap:8,overflowX:"auto"}}>
            {rifasActivas.map((r)=>(
              <button key={r.id} onClick={()=>setRifaSel(rifas.indexOf(r))} style={{flexShrink:0,padding:"6px 14px",borderRadius:99,fontSize:11,cursor:"pointer",fontFamily:"inherit",background:rifaActiva?.id===r.id?`linear-gradient(135deg,${GOLD},${GOLD2})`:DARK4,border:`1px solid ${rifaActiva?.id===r.id?GOLD:BORDER}`,color:rifaActiva?.id===r.id?DARK:MUTED,fontWeight:rifaActiva?.id===r.id?"bold":"normal"}}>
                {r.nombre}
              </button>
            ))}
          </div>
        </div>
      )}

      <main style={{padding:"16px",maxWidth:480,margin:"0 auto",position:"relative",zIndex:1}}>
        {tab===0&&rifaActiva&&<TabParticipar rifa={rifaActiva} cuentas={cuentas} boletosConfirmados={boletosConfirmados} mostrarReferido={configGeneral.mostrarReferido}/>}
        {tab===1&&rifaActiva&&<TabBoletos rifa={rifaActiva} boletosConfirmados={boletosConfirmados}/>}
        {tab===2&&<TabFAQ/>}
        <a href={CANAL_WHATSAPP} target="_blank" rel="noopener noreferrer" style={{display:"block",textAlign:"center",background:DARK3,border:`1px solid ${GOLD}44`,borderRadius:16,padding:"14px 16px",textDecoration:"none",marginTop:4}}>
          <p style={{margin:0,color:GOLD,fontSize:13}}>📢 Únete a nuestro canal de WhatsApp</p>
          <p style={{margin:"4px 0 0",color:MUTED,fontSize:10}}>Ganadores, premios instantáneos y avances del sorteo antes que nadie</p>
        </a>

        {/* ── Footer legal ── */}
        <footer style={{marginTop:24,paddingTop:20,borderTop:`1px solid ${BORDER}`}}>
          <p style={{color:GOLD,fontSize:10,letterSpacing:1,textTransform:"uppercase",margin:"0 0 6px",fontWeight:"bold"}}>Operado por</p>
          <p style={{color:WHITE,fontSize:13,fontWeight:"bold",margin:"0 0 2px"}}>Mia Arisleidy San Juan</p>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 2px"}}>Nombre comercial <strong style={{color:MUTED}}>WinnersRD</strong></p>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 10px"}}>RNC / Cédula: </p>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 10px"}}>📍 Higüey, La Altagracia, República Dominicana</p>

          <p style={{color:GOLD,fontSize:10,letterSpacing:1,textTransform:"uppercase",margin:"14px 0 6px",fontWeight:"bold"}}>Contacto</p>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 2px"}}>WhatsApp: 829-917-7634</p>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 2px"}}>Correo: winners.rd0@gmail.com</p>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 14px"}}>Instagram: @winnersrd</p>

          <div style={{background:DARK2,border:`1px solid ${GOLD}33`,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
            <p style={{margin:0,fontSize:10,color:MUTED,lineHeight:1.7}}>
              Esta promoción no está patrocinada, avalada ni administrada por Meta Platforms, Inc. ni está asociada a Instagram, Facebook o WhatsApp de ninguna forma. Instagram y WhatsApp se utilizan únicamente como canales de difusión y atención al cliente. La compra de boletos se realiza exclusivamente en <strong style={{color:WHITE}}>winnersrd.web.app</strong>. Al participar, usted exime de toda responsabilidad a Meta Platforms, Inc. Solo mayores de 18 años.
            </p>
          </div>

          <p style={{color:MUTED2,fontSize:10,textAlign:"center",margin:0}}>WinnersRD © 2026. Todos los derechos reservados.</p>
        </footer>
      </main>
    </div>
  );
}

// ─── UI ───────────────────────────────────────────────────────────────────────
const Card=({children,style={}})=><div style={{background:DARK3,border:`1px solid ${BORDER}`,borderRadius:16,padding:"20px",marginBottom:12,...style}}>{children}</div>;
const GDiv=()=><div style={{height:1,background:`linear-gradient(90deg,transparent,${GOLD}44,transparent)`,margin:"14px 0"}}/>;
const BtnG=({children,onClick,disabled,style={}})=>(
  <button onClick={onClick} disabled={disabled} style={{width:"100%",padding:"13px",border:"none",borderRadius:12,background:disabled?DARK4:`linear-gradient(135deg,${GOLD},${GOLD2})`,color:disabled?MUTED2:DARK,fontSize:14,fontWeight:"bold",cursor:disabled?"not-allowed":"pointer",fontFamily:"inherit",marginTop:8,boxShadow:disabled?"none":`0 4px 20px ${GOLD}40`,...style}}>{children}</button>
);
const Inp=({label,...props})=>(
  <div style={{marginBottom:12}}>
    {label&&<label style={{display:"block",fontSize:10,color:GOLD,marginBottom:5,letterSpacing:1,textTransform:"uppercase"}}>{label}</label>}
    <input style={{width:"100%",background:DARK2,border:`1px solid ${GOLD}44`,borderRadius:10,padding:"11px 13px",color:WHITE,fontSize:14,boxSizing:"border-box",outline:"none",fontFamily:"inherit"}} {...props}/>
  </div>
);
const Num=({num,color=GOLD})=><div style={{background:`${color}18`,border:`2px solid ${color}`,borderRadius:8,padding:"6px 12px",color,fontWeight:"bold",fontSize:15,fontFamily:"monospace",letterSpacing:1}}>{num}</div>;

const Boleto=({num,rifaNombre,color=GREEN})=>(
  <div style={{position:"relative",display:"flex",alignItems:"stretch",background:DARK2,border:`1px solid ${color}55`,borderRadius:12,overflow:"hidden",boxShadow:`0 2px 10px ${color}1a`}}>
    <div style={{width:8,background:`linear-gradient(180deg,${color},${GOLD})`}}/>
    <div style={{flex:1,padding:"10px 14px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{fontSize:8,letterSpacing:1.5,color:MUTED2,textTransform:"uppercase"}}>🎟️ Boleto Oficial · WinnersRD</span>
      </div>
      <div style={{borderTop:`1px dashed ${color}66`,margin:"6px 0"}}/>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
        <span style={{fontFamily:"monospace",fontSize:22,fontWeight:"bold",letterSpacing:3,color}}>{num}</span>
        <span style={{fontSize:9,color:MUTED2,maxWidth:110,textAlign:"right",lineHeight:1.3}}>{rifaNombre}</span>
      </div>
    </div>
    <div style={{position:"absolute",left:4,top:-7,width:13,height:13,borderRadius:"50%",background:DARK3}}/>
    <div style={{position:"absolute",left:4,bottom:-7,width:13,height:13,borderRadius:"50%",background:DARK3}}/>
  </div>
);

function ProgressCard({rifa,boletosConfirmados}){
  const vendidos=boletosConfirmados.filter(b=>b.rifaId===rifa.id).length;
  const pct=Math.round((vendidos/totalBoletosRifa(rifa))*100);
  return(
    <Card style={{padding:0,overflow:"hidden"}}>
      {rifa.imagen&&(
        <div style={{width:"100%",height:180,overflow:"hidden",borderRadius:"16px 16px 0 0"}}>
          <img src={rifa.imagen} alt={rifa.nombre} style={{width:"100%",height:"100%",objectFit:"cover"}}
            onError={e=>e.target.style.display="none"}/>
        </div>
      )}
      <div style={{padding:"16px 20px"}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
        <div>
          <p style={{margin:0,color:WHITE,fontWeight:"bold",fontSize:14,fontStyle:"italic"}}>{rifa.nombre}</p>
          <p style={{margin:"2px 0 0",color:GOLD,fontSize:12}}>🏆 {rifa.premio}</p>
        </div>
        <span style={{color:GOLD,fontWeight:"bold",fontSize:pct<5?12:22,textAlign:"right",alignSelf:"center"}}>{pct<5?"🔥 Recién lanzada":`${pct}%`}</span>
      </div>
      <div style={{height:8,background:DARK2,borderRadius:99,marginBottom:12,border:`1px solid ${BORDER}`}}>
        <div style={{height:"100%",width:`${pct}%`,background:`linear-gradient(90deg,${GOLD},${GOLD2})`,borderRadius:99,boxShadow:`0 0 8px ${GOLD}66`,transition:"width 0.6s"}}/>
      </div>
      <div style={{display:"flex",gap:8}}>
        <div style={{flex:1,background:DARK2,borderRadius:8,padding:"8px",textAlign:"center"}}>
          <div style={{color:GOLD,fontWeight:"bold",fontSize:14}}>RD$ {rifa.precio}</div>
          <div style={{color:MUTED2,fontSize:9,marginTop:2}}>por boleto</div>
        </div>
        <div style={{flex:1,background:DARK2,borderRadius:8,padding:"8px",textAlign:"center"}}>
          <div style={{color:WHITE,fontWeight:"bold",fontSize:14}}>mín. {rifa.minBoletos}</div>
          <div style={{color:MUTED2,fontSize:9,marginTop:2}}>boletos</div>
        </div>
      </div>
      <GDiv/>
      <p style={{margin:0,fontSize:11,color:MUTED,lineHeight:1.6}}>
        {pct>=100?<span style={{color:GREEN}}>¡100% vendidos! El sorteo se realizará muy pronto. 🎉</span>
          :<>El sorteo se efectuará cuando se vendan el <strong style={{color:GOLD}}>100%</strong> de los boletos. <strong style={{color:WHITE}}>¡Apresúrate!</strong></>}
      </p>
      </div>
    </Card>
  );
}

// ─── Tab: Participar ──────────────────────────────────────────────────────────
function TabParticipar({rifa,cuentas,boletosConfirmados,mostrarReferido}){
  const [step,setStep]=useState(1);
  const [nombre,setNombre]=useState("");
  const [telefono,setTelefono]=useState("");
  const [referido,setReferido]=useState("");
  const [cantidad,setCantidad]=useState(rifa.minBoletos);
  const [aceptaTerminos,setAceptaTerminos]=useState(false);
  const [verTerminos,setVerTerminos]=useState(false);
  const [verBases,setVerBases]=useState(false);
  const [preview,setPreview]=useState(null);
  const [archivo,setArchivo]=useState(null);
  const [bancoAbierto,setBancoAbierto]=useState(null);
  const [copiado,setCopiado]=useState(null);
  const [enviado,setEnviado]=useState(false);
  const [subiendo,setSubiendo]=useState(false);
  const [error,setError]=useState("");
  const fileRef=useRef();
  const cant=Math.max(rifa.minBoletos,cantidad);

  const handleFile=e=>{
    const f=e.target.files[0];if(!f)return;
    setArchivo(f);
    // Comprimir imagen antes de guardar
    const reader=new FileReader();
    reader.onload=ev=>{
      const img=new Image();
      img.onload=()=>{
        const canvas=document.createElement("canvas");
        const MAX=600;
        let w=img.width,h=img.height;
        if(w>h){if(w>MAX){h=h*(MAX/w);w=MAX;}}else{if(h>MAX){w=w*(MAX/h);h=MAX;}}
        canvas.width=w;canvas.height=h;
        canvas.getContext("2d").drawImage(img,0,0,w,h);
        const compressed=canvas.toDataURL("image/jpeg",0.6);
        setPreview(compressed);
      };
      img.src=ev.target.result;
    };
    reader.readAsDataURL(f);
  };

  const enviar=async()=>{
    if(!archivo)return;
    setSubiendo(true);setError("");
    try{
      const solicitudId=`sol_${Date.now()}`;
      const fecha=new Date().toLocaleString("es-DO",{timeZone:"America/Santo_Domingo"});

      await setDoc(doc(db,"solicitudes",solicitudId),{
        id:solicitudId,
        rifaId:rifa.id,
        rifaNombre:rifa.nombre,
        comprador:nombre,
        telefono,
        cantidad:cant,
        precio:rifa.precio,
        total:cant*rifa.precio,
        comprobanteURL:preview,
        estado:"pendiente",
        creadoEn:fecha,
        referido:referido.trim()||null,
      });

      setEnviado(true);setStep(3);
    }catch(e){
      setError("Error al enviar. Intenta de nuevo.");
      console.error(e);
    }
    setSubiendo(false);
  };

  const reset=()=>{setStep(1);setNombre("");setTelefono("");setReferido("");setCantidad(rifa.minBoletos);setAceptaTerminos(false);setPreview(null);setArchivo(null);setEnviado(false);setError("");};

  if(verTerminos)return(
    <div>
      <button onClick={()=>setVerTerminos(false)} style={{background:"none",border:`1px solid ${BORDER}`,color:GOLD,borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontFamily:"inherit",marginBottom:14}}>← Volver</button>
      <Card>
        <h3 style={{color:GOLD,fontSize:15,margin:"0 0 14px",fontStyle:"italic"}}>📋 Términos y Condiciones</h3>
        <pre style={{color:MUTED,fontSize:11,lineHeight:1.8,whiteSpace:"pre-wrap",fontFamily:"inherit",margin:0}}>{TERMINOS}</pre>
      </Card>
    </div>
  );

  if(verBases)return(
    <div>
      <button onClick={()=>setVerBases(false)} style={{background:"none",border:`1px solid ${BORDER}`,color:GOLD,borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontFamily:"inherit",marginBottom:14}}>← Volver</button>
      <Card>
        <h3 style={{color:GOLD,fontSize:15,margin:"0 0 14px",fontStyle:"italic"}}>👑 Bases del Sorteo Activo</h3>
        <pre style={{color:MUTED,fontSize:11,lineHeight:1.8,whiteSpace:"pre-wrap",fontFamily:"inherit",margin:0}}>{rifa.bases||BASES_DEFAULT}</pre>
      </Card>
    </div>
  );

  if(enviado)return(
    <div>
      <ProgressCard rifa={rifa} boletosConfirmados={boletosConfirmados}/>
      <Card style={{textAlign:"center"}}>
        <div style={{fontSize:50,marginBottom:10}}>✅</div>
        <h2 style={{color:WHITE,fontSize:17,margin:"0 0 6px",fontStyle:"italic"}}>¡Solicitud enviada!</h2>
        <p style={{color:MUTED,fontSize:12,marginBottom:14}}>Estamos verificando tu pago. Una vez confirmado te enviamos tus números por WhatsApp.</p>
        <GDiv/>
        <div style={{background:DARK2,borderRadius:10,padding:"12px",marginBottom:14}}>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 4px"}}>Comprador</p>
          <p style={{color:WHITE,fontWeight:"bold",fontSize:14,margin:0}}>{nombre}</p>
          <p style={{color:MUTED,fontSize:12,margin:"4px 0 0"}}>📱 {telefono}</p>
        </div>
        <div style={{background:DARK2,borderRadius:10,padding:"12px",marginBottom:14}}>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 4px"}}>Detalle</p>
          <p style={{color:GOLD,fontWeight:"bold",fontSize:16,margin:0}}>{cant} boletos — RD$ {(cant*rifa.precio).toLocaleString()}</p>
        </div>
        <div style={{background:`${GOLD}15`,border:`1px solid ${GOLD}44`,borderRadius:10,padding:"12px",marginBottom:14}}>
          <p style={{color:GOLD,fontSize:12,margin:0}}>🎟️ Tus números serán asignados de manera <strong>automática y al azar</strong> por el sistema una vez verifiquemos tu pago. Los recibirás directamente en tu WhatsApp.</p>
        </div>
        <a href={CANAL_WHATSAPP} target="_blank" rel="noopener noreferrer" style={{display:"block",textAlign:"center",background:`${GOLD}15`,border:`1px solid ${GOLD}66`,borderRadius:10,padding:"12px",marginBottom:14,textDecoration:"none"}}>
          <p style={{color:GOLD,fontSize:12,margin:0,fontWeight:"bold"}}>📢 Mientras verificamos tu pago, únete a nuestro canal de WhatsApp</p>
          <p style={{color:MUTED,fontSize:10,margin:"4px 0 0"}}>Ahí anunciamos ganadores y el progreso del sorteo antes que nadie</p>
        </a>
        <BtnG onClick={reset}>Comprar más boletos</BtnG>
      </Card>
    </div>
  );

  return(
    <div>
      <ProgressCard rifa={rifa} boletosConfirmados={boletosConfirmados}/>
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:6,marginBottom:12}}>
        {["Datos","Pagar","Listo"].map((label,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:5}}>
            <div style={{width:22,height:22,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:"bold",background:step>i+1?GOLD:step===i+1?`${GOLD}22`:DARK4,border:`2px solid ${step>=i+1?GOLD:BORDER}`,color:step>i+1?DARK:step===i+1?GOLD:MUTED2}}>
              {step>i+1?"✓":i+1}
            </div>
            <span style={{fontSize:10,color:step===i+1?GOLD:MUTED2}}>{label}</span>
            {i<2&&<div style={{width:14,height:1,background:BORDER}}/>}
          </div>
        ))}
      </div>

      <Card>
        {error&&<div style={{background:`${RED}20`,border:`1px solid ${RED}`,borderRadius:8,padding:"8px 12px",marginBottom:12,color:RED,fontSize:12}}>{error}</div>}

        {step===1&&<>
          <h3 style={{color:WHITE,fontSize:15,margin:"0 0 4px",fontStyle:"italic"}}>Reserva tus boletos</h3>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 12px"}}>Completa tus datos y realiza el pago.</p>
          <div style={{background:DARK2,border:`1px solid ${GOLD}33`,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
            <p style={{margin:0,fontSize:11,color:MUTED,lineHeight:1.7}}>🎯 <strong style={{color:GOLD}}>¿Cómo funciona?</strong> Pagas, subes el comprobante, verificamos y te enviamos tus números por <strong style={{color:WHITE}}>WhatsApp</strong>. ¡Siempre hay un ganador!</p>
          </div>
          <Inp label="Nombre completo" placeholder="Ej. Juan Pérez" value={nombre} onChange={e=>setNombre(e.target.value)}/>
          <Inp label="WhatsApp (aquí recibirás tus números)" placeholder="Ej. 809-555-0000" value={telefono} onChange={e=>setTelefono(e.target.value)}/>
          {mostrarReferido&&(
            <Inp label="Código de referido (opcional)" placeholder="" value={referido} onChange={e=>setReferido(e.target.value)}/>
          )}

          <label style={{display:"block",fontSize:10,color:MUTED,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Elige tu paquete <span style={{color:MUTED2}}>(mín. {rifa.minBoletos})</span></label>
          <style>{`
            @keyframes paqueteGlow{
              0%,100%{box-shadow:0 0 6px ${GOLD}55, inset 0 0 12px ${GOLD}11;}
              50%{box-shadow:0 0 18px ${GOLD}cc, inset 0 0 16px ${GOLD}33;}
            }
            .paquete-btn{animation:paqueteGlow 1.6s ease-in-out infinite;}
            .paquete-btn:hover{transform:scale(1.03);}
          `}</style>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
            {PAQUETES.map(p=>(
              <button key={p.n} onClick={()=>setCantidad(p.n)} className={cant===p.n?"":"paquete-btn"}
                style={{padding:"12px 6px",borderRadius:12,cursor:"pointer",fontFamily:"inherit",textAlign:"center",transition:"transform 0.15s",
                  background:cant===p.n?`linear-gradient(135deg,${GOLD},${GOLD2})`:`linear-gradient(135deg,${GOLD}26,${DARK4})`,
                  border:`1.5px solid ${cant===p.n?GOLD:GOLD+"88"}`,
                  color:cant===p.n?DARK:WHITE}}>
                <div style={{fontWeight:"bold",fontSize:13}}>{p.label}</div>
                <div style={{fontSize:11,marginTop:2,color:cant===p.n?DARK:GOLD2}}>{p.n} boletos</div>
                <div style={{fontSize:10,marginTop:2,opacity:0.9}}>RD$ {(p.n*rifa.precio).toLocaleString()}</div>
              </button>
            ))}
          </div>
          <p style={{color:MUTED2,fontSize:10,margin:"0 0 8px",textAlign:"center"}}>o ajusta la cantidad manualmente:</p>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
            <button onClick={()=>setCantidad(c=>Math.max(rifa.minBoletos,c-rifa.minBoletos))} style={{width:32,height:32,borderRadius:8,background:DARK4,border:`1px solid ${BORDER}`,color:MUTED,fontSize:16,cursor:"pointer"}}>−</button>
            <span style={{color:GOLD,fontSize:18,fontWeight:"bold",minWidth:32,textAlign:"center"}}>{cant}</span>
            <button onClick={()=>setCantidad(c=>c+rifa.minBoletos)} style={{width:32,height:32,borderRadius:8,background:DARK4,border:`1px solid ${BORDER}`,color:MUTED,fontSize:16,cursor:"pointer"}}>+</button>
          </div>
          <GDiv/>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"12px 0"}}>
            <span style={{color:MUTED,fontSize:12}}>Total a pagar</span>
            <span style={{color:GOLD,fontWeight:"bold",fontSize:20}}>RD$ {(cant*rifa.precio).toLocaleString()}</span>
          </div>

          <div style={{background:DARK2,border:`1px solid ${aceptaTerminos?GOLD:BORDER}`,borderRadius:10,padding:"12px",marginBottom:12,display:"flex",alignItems:"flex-start",gap:10}}>
            <div onClick={()=>setAceptaTerminos(!aceptaTerminos)} style={{width:20,height:20,borderRadius:4,border:`2px solid ${aceptaTerminos?GOLD:BORDER}`,background:aceptaTerminos?GOLD:DARK4,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0,marginTop:1}}>
              {aceptaTerminos&&<span style={{color:DARK,fontSize:12,fontWeight:"bold"}}>✓</span>}
            </div>
            <p style={{margin:0,fontSize:11,color:MUTED,lineHeight:1.6}}>
              Acepto los{" "}<span onClick={()=>setVerTerminos(true)} style={{color:GOLD,cursor:"pointer",textDecoration:"underline"}}>términos y condiciones</span>{" "}y las{" "}<span onClick={()=>setVerBases(true)} style={{color:GOLD,cursor:"pointer",textDecoration:"underline"}}>bases de este sorteo</span>{" "}de WinnersRD.
            </p>
          </div>

          <BtnG onClick={()=>setStep(2)} disabled={!nombre.trim()||!telefono.trim()||!aceptaTerminos}>
            {!aceptaTerminos?"Acepta los términos para continuar":"Continuar al pago →"}
          </BtnG>
        </>}

        {step===2&&<>
          <h3 style={{color:WHITE,fontSize:15,margin:"0 0 4px",fontStyle:"italic"}}>Realiza tu pago</h3>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 12px"}}>Transfiere y sube tu comprobante.</p>

          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"12px 0"}}>
            <span style={{color:MUTED,fontSize:12}}>Monto a transferir</span>
            <span style={{color:GOLD,fontWeight:"bold",fontSize:20}}>RD$ {(cant*rifa.precio).toLocaleString()}</span>
          </div>
          <GDiv/>

          <p style={{color:WHITE,fontSize:12,fontWeight:"bold",margin:"12px 0 8px"}}>💳 Transfiere a cualquiera de estas cuentas:</p>
          {cuentas.map(({banco,cuenta,icon,titular},i)=>{
            const abierto=bancoAbierto===i;
            return(
              <div key={i} style={{border:`1px solid ${abierto?GOLD+"55":BORDER}`,borderRadius:10,marginBottom:8,overflow:"hidden"}}>
                <button onClick={()=>setBancoAbierto(abierto?null:i)} style={{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 12px",background:abierto?`${GOLD}12`:"transparent",border:"none",cursor:"pointer",fontFamily:"inherit"}}>
                  <span style={{color:WHITE,fontSize:13,fontWeight:"bold"}}>{icon} {banco}</span>
                  <span style={{color:GOLD,fontSize:12}}>{abierto?"▲":"▼"}</span>
                </button>
                {abierto&&(
                  <div style={{padding:"0 12px 12px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:DARK,borderRadius:8,padding:"8px 10px",marginBottom:6}}>
                      <span style={{color:GOLD,fontFamily:"monospace",fontWeight:"bold",fontSize:13}}>{cuenta}</span>
                      <button onClick={()=>{navigator.clipboard?.writeText(cuenta);setCopiado(i);setTimeout(()=>setCopiado(null),1500);}} style={{background:copiado===i?`${GREEN}22`:`${GOLD}18`,border:`1px solid ${copiado===i?GREEN:GOLD}`,color:copiado===i?GREEN:GOLD,borderRadius:6,padding:"4px 10px",fontSize:10,fontWeight:"bold",cursor:"pointer",fontFamily:"inherit"}}>{copiado===i?"✓ Copiado":"📋 Copiar"}</button>
                    </div>
                    <div style={{color:MUTED2,fontSize:10}}>A nombre de: <strong style={{color:WHITE}}>{titular||TITULAR}</strong></div>
                  </div>
                )}
              </div>
            );
          })}
          <GDiv/>

          <label style={{display:"block",fontSize:10,color:MUTED,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Sube tu comprobante de pago</label>
          <div onClick={()=>fileRef.current.click()} style={{border:`2px dashed ${preview?GOLD:BORDER}`,borderRadius:12,padding:"16px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",marginBottom:10,minHeight:90,background:DARK2,transition:"border-color 0.2s"}}>
            {preview?<img src={preview} alt="comprobante" style={{maxHeight:150,borderRadius:8,objectFit:"contain"}}/>
              :<div style={{textAlign:"center",color:MUTED2}}><div style={{fontSize:28,marginBottom:4}}>📎</div><p style={{margin:0,fontSize:12}}>Toca para subir tu comprobante</p><p style={{margin:"4px 0 0",fontSize:10}}>JPG, PNG o PDF</p></div>}
          </div>
          <input ref={fileRef} type="file" accept="image/*,application/pdf" style={{display:"none"}} onChange={handleFile}/>

          <BtnG onClick={enviar} disabled={!archivo||subiendo}>
            {subiendo?"Enviando... ⏳":"Enviar comprobante ✓"}
          </BtnG>
        </>}
      </Card>
    </div>
  );
}

// ─── Tab: Boletos ─────────────────────────────────────────────────────────────
function TabBoletos({rifa,boletosConfirmados}){
  const [telefono,setTelefono]=useState("");
  const [buscado,setBuscado]=useState(false);
  const vendidos=boletosConfirmados.filter(b=>b.rifaId===rifa.id).length;
  const pct=Math.round((vendidos/totalBoletosRifa(rifa))*100);

  const misBoletos=telefono.trim()
    ?boletosConfirmados.filter(b=>b.rifaId===rifa.id&&b.telefono.replace(/\D/g,"").includes(telefono.replace(/\D/g,"")))
    :[];

  return(
    <div>
      <Card>
        <h3 style={{color:WHITE,fontSize:14,margin:"0 0 10px",fontStyle:"italic"}}>{rifa.nombre}</h3>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
          <span style={{color:MUTED,fontSize:11}}>🎟️ Progreso de venta</span>
          <span style={{color:GOLD,fontWeight:"bold",fontSize:pct<5?11:18}}>{pct<5?"🔥 Recién lanzada":`${pct}%`}</span>
        </div>
        <div style={{height:8,background:DARK2,borderRadius:99,marginBottom:12}}>
          <div style={{height:"100%",width:`${pct}%`,background:`linear-gradient(90deg,${GOLD},${GOLD2})`,borderRadius:99,boxShadow:`0 0 8px ${GOLD}66`,transition:"width 0.5s"}}/>
        </div>
        <GDiv/>
        <p style={{margin:0,fontSize:11,color:MUTED}}>
          {pct>=100?<span style={{color:GREEN}}>¡100% vendidos! Sorteo próximamente. 🎉</span>
            :<>El sorteo se efectuará cuando se vendan el <strong style={{color:GOLD}}>100%</strong> de los boletos.</>}
        </p>
      </Card>

      <Card>
        <h4 style={{color:WHITE,fontSize:13,margin:"0 0 10px",fontStyle:"italic"}}>🔍 Ver mis boletos</h4>
        <p style={{color:MUTED,fontSize:11,margin:"0 0 10px"}}>Escribe tu WhatsApp para ver tus números asignados.</p>
        <Inp label="Tu número de WhatsApp" placeholder="Ej. 809-555-0000" value={telefono} onChange={e=>{setTelefono(e.target.value);setBuscado(false);}}/>
        <BtnG onClick={()=>setBuscado(true)} disabled={!telefono.trim()}>Buscar mis boletos</BtnG>

        {buscado&&telefono.trim()&&(
          <div style={{marginTop:16}}>
            <GDiv/>
            {misBoletos.length===0?(
              <p style={{color:MUTED2,textAlign:"center",fontSize:12,margin:"8px 0"}}>
                No se encontraron boletos confirmados para ese número. Si acabas de comprar, espera la confirmación. 😊
              </p>
            ):(
              <>
                <p style={{color:GREEN,fontSize:11,letterSpacing:1,textTransform:"uppercase",margin:"0 0 8px"}}>🟢 Tus boletos confirmados</p>
                <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:8}}>
                  {misBoletos.map(b=>b.numeros?.map(n=><Boleto key={n} num={n} rifaNombre={b.rifaNombre}/>))}
                </div>
                <p style={{color:MUTED2,fontSize:11,margin:"8px 0 0",textAlign:"center"}}>
                  Total: <strong style={{color:WHITE}}>{misBoletos.reduce((acc,b)=>acc+(b.numeros?.length||0),0)}</strong> boletos activos
                </p>
              </>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}

// ─── Tab: Sorteo ──────────────────────────────────────────────────────────────
function TabSorteo({rifa,boletosConfirmados}){
  const [digits,setDigits]=useState(["","","",""]);
  const [resultado,setResultado]=useState(null);
  const refs=[useRef(),useRef(),useRef(),useRef()];

  const handleDigit=(i,val)=>{if(!/^\d?$/.test(val))return;const d=[...digits];d[i]=val;setDigits(d);setResultado(null);if(val&&i<3)refs[i+1].current.focus();};
  const handleKey=(i,e)=>{if(e.key==="Backspace"&&!digits[i]&&i>0)refs[i-1].current.focus();};

  const verificar=()=>{
    const numero=digits.join("");if(numero.length<4)return;
    const ganador=boletosConfirmados.find(b=>b.rifaId===rifa.id&&b.numeros?.includes(numero));
    if(ganador)setResultado({ganador:true,numero,comprador:ganador.comprador,telefono:ganador.telefono});
    else setResultado({ganador:false,numero});
  };
  const reset=()=>{setDigits(["","","",""]);setResultado(null);};

  return(
    <Card>
      <h3 style={{color:WHITE,fontSize:15,margin:"0 0 4px",fontStyle:"italic",textAlign:"center"}}>🎯 Verificar Número</h3>
      <p style={{color:MUTED,fontSize:11,textAlign:"center",margin:"0 0 22px"}}>Ingresa el número ganador del sorteo</p>
      <div style={{display:"flex",gap:8,justifyContent:"center",marginBottom:22}}>
        {digits.map((d,i)=>(
          <input key={i} ref={refs[i]} value={d} onChange={e=>handleDigit(i,e.target.value)} onKeyDown={e=>handleKey(i,e)} maxLength={1}
            style={{width:54,height:64,textAlign:"center",fontSize:28,fontWeight:"bold",fontFamily:"monospace",background:DARK2,border:`2px solid ${d?GOLD:BORDER}`,borderRadius:12,color:GOLD,outline:"none",boxShadow:d?`0 0 12px ${GOLD}44`:"none"}}/>
        ))}
      </div>
      {resultado&&(
        <div style={{borderRadius:14,padding:"16px",marginBottom:12,textAlign:"center",background:resultado.ganador?`${GREEN}15`:`${RED}15`,border:`2px solid ${resultado.ganador?GREEN:RED}`}}>
          {resultado.ganador?<>
            <div style={{fontSize:38,marginBottom:6}}>🏆</div>
            <p style={{color:GOLD,fontWeight:"bold",fontSize:15,margin:"0 0 4px",fontStyle:"italic"}}>¡TENEMOS GANADOR!</p>
            <p style={{color:WHITE,fontSize:20,margin:"0 0 4px",fontFamily:"monospace",fontWeight:"bold",letterSpacing:4}}>{resultado.numero}</p>
            <p style={{color:WHITE,fontSize:15,margin:"0 0 4px"}}>{resultado.comprador}</p>
            <p style={{color:MUTED,fontSize:12,marginBottom:12}}>📱 {resultado.telefono}</p>
            <a href={`https://wa.me/${resultado.telefono.replace(/\D/g,"")}`}
              target="_blank"
              style={{display:"inline-flex",alignItems:"center",gap:8,background:"#25D366",borderRadius:10,padding:"10px 20px",color:WHITE,fontWeight:"bold",fontSize:14,textDecoration:"none",fontFamily:"inherit"}}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Contactar por WhatsApp
            </a>
          </>:<>
            <div style={{fontSize:30}}>😔</div>
            <p style={{color:RED,fontWeight:"bold",fontSize:13,margin:"6px 0"}}>Sin ganador</p>
            <p style={{color:MUTED,fontSize:12}}>El número <strong style={{color:WHITE}}>{resultado.numero}</strong> no fue vendido.</p>
          </>}
        </div>
      )}
      <BtnG onClick={resultado?reset:verificar} disabled={!resultado&&digits.join("").length<4}>
        {resultado?"🔄 Verificar otro":"🎯 Verificar ganador"}
      </BtnG>
    </Card>
  );
}

// ─── Tab: FAQ ─────────────────────────────────────────────────────────────────
function TabFAQ(){
  const [abierto,setAbierto]=useState(null);
  const [verTerminos,setVerTerminos]=useState(false);
  const [verBases,setVerBases]=useState(false);

  if(verTerminos)return(
    <div>
      <button onClick={()=>setVerTerminos(false)} style={{background:"none",border:`1px solid ${BORDER}`,color:GOLD,borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontFamily:"inherit",marginBottom:14}}>← Volver</button>
      <Card>
        <h3 style={{color:GOLD,fontSize:15,margin:"0 0 14px",fontStyle:"italic"}}>📋 Términos y Condiciones</h3>
        <pre style={{color:MUTED,fontSize:11,lineHeight:1.8,whiteSpace:"pre-wrap",fontFamily:"inherit",margin:0}}>{TERMINOS}</pre>
      </Card>
    </div>
  );

  if(verBases)return(
    <div>
      <button onClick={()=>setVerBases(false)} style={{background:"none",border:`1px solid ${BORDER}`,color:GOLD,borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontFamily:"inherit",marginBottom:14}}>← Volver</button>
      <Card>
        <h3 style={{color:GOLD,fontSize:15,margin:"0 0 14px",fontStyle:"italic"}}>👑 Bases del Sorteo Activo</h3>
        <pre style={{color:MUTED,fontSize:11,lineHeight:1.8,whiteSpace:"pre-wrap",fontFamily:"inherit",margin:0}}>{rifa.bases||BASES_DEFAULT}</pre>
      </Card>
    </div>
  );

  return(
    <div>
      <Card style={{textAlign:"center",marginBottom:12}}>
        <div style={{fontSize:32,marginBottom:8}}>❓</div>
        <h3 style={{color:WHITE,fontSize:16,margin:"0 0 4px",fontStyle:"italic"}}>Preguntas Frecuentes</h3>
        <p style={{color:MUTED,fontSize:12,margin:0}}>Todo lo que necesitas saber sobre WinnersRD</p>
      </Card>
      {FAQS.map((faq,i)=>(
        <div key={i} style={{background:DARK3,border:`1px solid ${abierto===i?GOLD:BORDER}`,borderRadius:16,padding:"14px 16px",marginBottom:10,cursor:"pointer",transition:"border-color 0.2s"}}
          onClick={()=>setAbierto(abierto===i?null:i)}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
            <p style={{margin:0,color:WHITE,fontSize:13,fontWeight:"bold",lineHeight:1.4,flex:1}}>{faq.q}</p>
            <div style={{width:24,height:24,borderRadius:"50%",background:abierto===i?`linear-gradient(135deg,${GOLD},${GOLD2})`:DARK4,border:`1px solid ${abierto===i?GOLD:BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:14,color:abierto===i?DARK:MUTED,fontWeight:"bold"}}>
              {abierto===i?"−":"+"}
            </div>
          </div>
          {abierto===i&&<div style={{marginTop:10,paddingTop:10,borderTop:`1px solid ${BORDER}`}}><p style={{margin:0,color:MUTED,fontSize:12,lineHeight:1.8}}>{faq.a}</p></div>}
        </div>
      ))}
      <div style={{background:DARK3,border:`1px solid ${GOLD}44`,borderRadius:16,padding:"14px 16px",cursor:"pointer",textAlign:"center",marginBottom:10}} onClick={()=>setVerBases(true)}>
        <p style={{margin:0,color:GOLD,fontSize:13}}>👑 Ver Bases del Sorteo Activo</p>
      </div>
      <div style={{background:DARK3,border:`1px solid ${GOLD}44`,borderRadius:16,padding:"14px 16px",cursor:"pointer",textAlign:"center"}} onClick={()=>setVerTerminos(true)}>
        <p style={{margin:0,color:GOLD,fontSize:13}}>📋 Ver Términos y Condiciones completos</p>
      </div>
    </div>
  );
}

// ─── Admin Sorteo (Verificador de Números) ───────────────────────────────────────
function AdminSorteo({boletosConfirmados,rifas}){
  const [digits,setDigits]=useState(["","","",""]);
  const [rifaId,setRifaId]=useState(rifas[0]?.id||"");
  const [resultado,setResultado]=useState(null);
  const refs=[useRef(),useRef(),useRef(),useRef()];

  const handleDigit=(i,val)=>{
    if(!/^\d?$/.test(val))return;
    const d=[...digits];d[i]=val;setDigits(d);setResultado(null);
    if(val&&i<3)refs[i+1].current?.focus();
  };
  const handleKey=(i,e)=>{if(e.key==="Backspace"&&!digits[i]&&i>0)refs[i-1].current?.focus();};

  const verificar=()=>{
    const numero=digits.join("");if(numero.length<4)return;
    const ganador=boletosConfirmados.find(b=>
      (!rifaId||b.rifaId===rifaId)&&b.numeros?.includes(numero)
    );
    if(ganador)setResultado({ganador:true,numero,comprador:ganador.comprador,telefono:ganador.telefono,rifaNombre:ganador.rifaNombre});
    else setResultado({ganador:false,numero});
  };
  const reset=()=>{setDigits(["","","",""]);setResultado(null);};

  return(
    <div>
      <Card>
        <h3 style={{color:WHITE,fontSize:15,margin:"0 0 4px",fontStyle:"italic",textAlign:"center"}}>🎯 Verificador de Números</h3>
        <p style={{color:MUTED,fontSize:11,textAlign:"center",margin:"0 0 16px"}}>Ingresa el número ganador del sorteo</p>

        {rifas.length>1&&(
          <div style={{marginBottom:14}}>
            <label style={{display:"block",fontSize:10,color:MUTED,marginBottom:5,letterSpacing:1,textTransform:"uppercase"}}>Selecciona el sorteo</label>
            <select value={rifaId} onChange={e=>setRifaId(e.target.value)} style={{width:"100%",background:DARK2,border:`1px solid ${BORDER}`,borderRadius:10,padding:"10px 13px",color:WHITE,fontSize:13,outline:"none",fontFamily:"inherit"}}>
              {rifas.map(r=><option key={r.id} value={r.id}>{r.nombre}</option>)}
            </select>
          </div>
        )}

        <div style={{display:"flex",gap:8,justifyContent:"center",marginBottom:20}}>
          {digits.map((d,i)=>(
            <input key={i} ref={refs[i]} value={d}
              onChange={e=>handleDigit(i,e.target.value)}
              onKeyDown={e=>handleKey(i,e)}
              maxLength={1}
              style={{width:58,height:68,textAlign:"center",fontSize:30,fontWeight:"bold",fontFamily:"monospace",background:DARK2,border:`2px solid ${d?GOLD:BORDER}`,borderRadius:12,color:GOLD,outline:"none",boxShadow:d?`0 0 12px ${GOLD}44`:"none",transition:"all 0.2s"}}
            />
          ))}
        </div>

        {resultado&&(
          <div style={{borderRadius:14,padding:"20px",marginBottom:16,textAlign:"center",background:resultado.ganador?`${GREEN}15`:`${RED}15`,border:`2px solid ${resultado.ganador?GREEN:RED}`}}>
            {resultado.ganador?<>
              <div style={{fontSize:44,marginBottom:8}}>🏆</div>
              <p style={{color:GOLD,fontWeight:"bold",fontSize:18,margin:"0 0 6px",fontStyle:"italic"}}>¡TENEMOS GANADOR!</p>
              <p style={{color:WHITE,fontSize:22,margin:"0 0 4px",fontFamily:"monospace",fontWeight:"bold",letterSpacing:4}}>{resultado.numero}</p>
              <p style={{color:WHITE,fontSize:16,margin:"0 0 4px"}}>{resultado.comprador}</p>
              <p style={{color:MUTED,fontSize:13,margin:"0 0 4px"}}>📱 {resultado.telefono}</p>
              <p style={{color:MUTED2,fontSize:11}}>{resultado.rifaNombre}</p>
            </>:<>
              <div style={{fontSize:36,marginBottom:8}}>😔</div>
              <p style={{color:RED,fontWeight:"bold",fontSize:15,margin:"0 0 6px"}}>Sin ganador</p>
              <p style={{color:MUTED,fontSize:13}}>El número <strong style={{color:WHITE}}>{resultado.numero}</strong> no fue vendido en este sorteo.</p>
            </>}
          </div>
        )}

        <BtnG onClick={resultado?reset:verificar} disabled={!resultado&&digits.join("").length<4}>
          {resultado?"🔄 Verificar otro número":"🎯 Verificar ganador"}
        </BtnG>

        <div style={{background:DARK2,borderRadius:10,padding:"10px 12px",marginTop:12}}>
          <p style={{margin:0,fontSize:11,color:MUTED2,textAlign:"center"}}>
            🔒 Esta sección es privada y solo visible para el administrador
          </p>
        </div>
      </Card>
    </div>
  );
}

// ─── Tab: Admin ───────────────────────────────────────────────────────────────
function TabAdmin({rifas,solicitudes,boletosConfirmados,cuentas,setCuentas,adminAuth,setAdminAuth,updateRifa,configGeneral,toggleConfigGeneral}){
  const [seccion,setSeccion]=useState("pagos");
  const [rifaEditando,setRifaEditando]=useState(null);
  const [rifaLocal,setRifaLocal]=useState({});
  const [nuevoBanco,setNuevoBanco]=useState("");
  const [nuevaCuenta,setNuevaCuenta]=useState("");
  const [nuevoTitular,setNuevoTitular]=useState("");
  const [busqueda,setBusqueda]=useState("");
  const [codigoEliminar,setCodigoEliminar]=useState({});
  const [verMas,setVerMas]=useState(false);
  const [adminInput,setAdminInput]=useState("");
  const [password,setPassword]=useState("");
  const [pin,setPin]=useState("");
  const [authError,setAuthError]=useState("");
  const [authLoading,setAuthLoading]=useState(false);
  const [step,setStepAuth]=useState(1); // 1=contraseña, 2=PIN

  const totalVendidos=boletosConfirmados.length;
  const totalRecaudado=boletosConfirmados.reduce((acc,b)=>acc+(b.total||0),0);

  const ranking=Object.values(
    boletosConfirmados.reduce((acc,b)=>{
      const key=b.telefono;
      if(!acc[key])acc[key]={nombre:b.comprador,telefono:b.telefono,boletos:0,gasto:0,primerCompra:b.creadoEn||b.confirmadoEn||""};
      acc[key].boletos+=(b.numeros?.length||0);
      acc[key].gasto+=(b.total||0);
      // Guardar la fecha más antigua (primera compra)
      if(b.creadoEn&&b.creadoEn<acc[key].primerCompra)acc[key].primerCompra=b.creadoEn;
      return acc;
    },{})
  ).sort((a,b)=>{
    if(b.boletos!==a.boletos)return b.boletos-a.boletos;
    return a.primerCompra.localeCompare(b.primerCompra); // empate: gana quien compró primero
  });

  const solicitudesFiltradas=solicitudes.filter(s=>
    !busqueda||
    s.comprador?.toLowerCase().includes(busqueda.toLowerCase())||
    s.telefono?.includes(busqueda)||
    s.rifaNombre?.toLowerCase().includes(busqueda.toLowerCase())
  );

  const handleLogin=async()=>{
    setAuthError("");
    if(step===1){
      if(!password)return;
      setAuthLoading(true);
      try{
        // Esto es lo que de verdad protege la base de datos — no la
        // contraseña sola, sino que Firestore exige haber iniciado sesión.
        await signInWithEmailAndPassword(auth,ADMIN_EMAIL,password);
        setStepAuth(2);
      }catch(e){
        setAuthError("Credenciales incorrectas ❌");
      }
      setAuthLoading(false);
    }else{
      if(!pin)return;
      if(pin===ADMIN_PIN){/* adminAuth ya lo activa onAuthStateChanged en cuanto inicias sesión arriba */}
      else{setAuthError("PIN incorrecto ❌");setPin("");}
    }
  };

  // Confirmar solicitud: asignar números aleatorios
  const confirmar=async(solicitud)=>{
    try{
      const rifaDeSolicitud=rifas.find(rf=>rf.id===solicitud.rifaId);
      const digitos=rifaDeSolicitud?.digitos||4;
      const totalDeEstaRifa=Math.pow(10,digitos);
      const lot=loteriaDeRifa(rifaDeSolicitud);
      const usados=new Set(boletosConfirmados.filter(b=>b.rifaId===solicitud.rifaId).flatMap(b=>b.numeros||[]));
      const disponibles=[];
      for(let i=0;i<totalDeEstaRifa;i++){const n=fmt(i,digitos);if(!usados.has(n))disponibles.push(n);}
      const numerosAsignados=disponibles.sort(()=>Math.random()-0.5).slice(0,solicitud.cantidad);

      await setDoc(doc(db,"boletos",solicitud.id),{
        ...solicitud,
        numeros:numerosAsignados,
        estado:"confirmado",
        confirmadoEn:new Date().toISOString(),
      });
      await deleteDoc(doc(db,"solicitudes",solicitud.id));

      // WhatsApp al cliente con sus números en formato boletito
      const nums=numerosAsignados.map(n=>`🎟️ [${n}]`).join("\n");
      const msg=`¡Hola ${solicitud.comprador}! ✨ Tu pago fue confirmado en *WinnersRD*.\n\nTus números asignados son:\n\n${nums}\n\n🍀 ¡Mucha suerte! Si el resultado de *${lot.label}* (${lot.horario}) coincide exactamente con alguno de tus números, ¡ganaste el premio!\n\n_WinnersRD — Rifas Seguras, Premios Reales_ 🎰`;
      enviarWhatsApp(solicitud.telefono, msg);

    }catch(e){console.error("Error confirmando:",e);}
  };

  const rechazarFraude=async(solicitud)=>{
    await deleteDoc(doc(db,"solicitudes",solicitud.id));
    // Sin notificación — solicitud eliminada silenciosamente
  };

  const rechazarPagoNoCaido=async(boleto)=>{
    await deleteDoc(doc(db,"boletos",boleto.id));
    const msg=`Hola ${boleto.comprador}, lamentablemente tu boleto WinnersRD fue cancelado ❌\n\nMotivo: No pudimos verificar tu pago en el sistema bancario.\n\nSi realizaste el pago, por favor contáctanos con tu comprobante.\n\n_WinnersRD_`;
    enviarWhatsApp(boleto.telefono, msg);
  };

  const agregarCuenta=async()=>{
    if(!nuevoBanco||!nuevaCuenta)return;
    const nuevasCuentas=[...cuentas,{banco:nuevoBanco,cuenta:nuevaCuenta,titular:nuevoTitular||TITULAR,icon:"🏦"}];
    setCuentas(nuevasCuentas);
    await setDoc(doc(db,"config","cuentas"),{lista:nuevasCuentas});
    setNuevoBanco("");setNuevaCuenta("");setNuevoTitular("");
  };
  const quitarCuenta=async(i)=>{
    const nuevasCuentas=cuentas.filter((_,idx)=>idx!==i);
    setCuentas(nuevasCuentas);
    await setDoc(doc(db,"config","cuentas"),{lista:nuevasCuentas});
  };

  if(!adminAuth)return(
    <Card>
      <div style={{textAlign:"center",marginBottom:16}}>
        <div style={{fontSize:32,marginBottom:6}}>🔐</div>
        <h3 style={{color:WHITE,fontSize:15,margin:"0 0 4px",fontStyle:"italic"}}>Acceso Admin</h3>
        <p style={{color:MUTED,fontSize:11,margin:0}}>Solo para el administrador de WinnersRD</p>
      </div>
      <GDiv/>
      {authError&&<div style={{background:`${RED}20`,border:`1px solid ${RED}`,borderRadius:8,padding:"8px 12px",marginBottom:12,color:RED,fontSize:12,textAlign:"center"}}>{authError}</div>}
      <Inp label="Contraseña" type="password" placeholder="••••••••" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
      <BtnG disabled={!password||authLoading} onClick={handleLogin}>{authLoading?"Verificando...":"Entrar al panel 🔓"}</BtnG>
    </Card>
  );

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div>
          <h3 style={{color:WHITE,margin:0,fontSize:15,fontStyle:"italic"}}>Panel Admin</h3>
          <p style={{color:MUTED2,fontSize:10,margin:0}}>WinnersRD</p>
        </div>
        <button onClick={()=>signOut(auth)} style={{background:"none",border:`1px solid ${BORDER}`,color:MUTED,borderRadius:8,padding:"5px 12px",cursor:"pointer",fontSize:11,fontFamily:"inherit"}}>Salir</button><button onClick={exportarBoletos} style={{background:"none",border:"1px solid "+GOLD,color:GOLD,cursor:"pointer",fontSize:11,fontFamily:"inherit",padding:"4px 10px",borderRadius:6,marginLeft:8}}>📥 Exportar Excel</button>
      </div>

      {/* Stats */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:6,marginBottom:12}}>
        {[["🎟️",rifas.filter(r=>r.activa).length,"Rifas"],["⏳",solicitudes.length,"Pendientes"],["✅",totalVendidos,"Vendidos"],["💰",`${(totalRecaudado/1000).toFixed(1)}K`,"RD$"]].map(([icon,val,label])=>(
          <div key={label} style={{background:DARK3,border:`1px solid ${BORDER}`,borderRadius:10,padding:"8px 4px",textAlign:"center"}}>
            <div style={{fontSize:13}}>{icon}</div>
            <div style={{color:GOLD,fontWeight:"bold",fontSize:14,margin:"2px 0"}}>{val}</div>
            <div style={{color:MUTED2,fontSize:8}}>{label}</div>
          </div>
        ))}
      </div>

      {/* Tabs internos */}
      <div style={{display:"flex",gap:5,marginBottom:12,overflowX:"auto"}}>
        {[["pagos","💳 Pagos",solicitudes.length],["rifas","🎟️ Sorteos",0],["sorteo","🎯 Sorteo",0],["ranking","🏅 Ranking",0],["cuentas","🏦 Cuentas",0],["config","⚙️ Config",0]].map(([key,label,badge])=>(
          <button key={key} onClick={()=>setSeccion(key)} style={{flexShrink:0,flex:1,padding:"7px 4px",borderRadius:10,cursor:"pointer",fontFamily:"inherit",fontSize:10,background:seccion===key?`linear-gradient(135deg,${GOLD},${GOLD2})`:DARK3,border:`1px solid ${seccion===key?GOLD:BORDER}`,color:seccion===key?DARK:MUTED,fontWeight:seccion===key?"bold":"normal",position:"relative"}}>
            {label}
            {badge>0&&<span style={{position:"absolute",top:-5,right:-5,background:RED,color:WHITE,borderRadius:"50%",width:15,height:15,fontSize:8,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:"bold"}}>{badge}</span>}
          </button>
        ))}
      </div>

      {/* PAGOS */}
      {seccion==="pagos"&&<>
        <Inp label="Buscar por nombre, teléfono o sorteo" placeholder="Ej. Juan / 809 / iPhone" value={busqueda} onChange={e=>setBusqueda(e.target.value)}/>
        {solicitudesFiltradas.length===0
          ?<Card><p style={{color:MUTED2,textAlign:"center",margin:0}}>{busqueda?"Sin resultados.":"✅ No hay pagos pendientes."}</p></Card>
          :solicitudesFiltradas.map((s)=>(
            <Card key={s.id}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                <div>
                  <p style={{color:WHITE,margin:0,fontWeight:"bold",fontSize:14}}>{s.comprador}</p>
                  <p style={{color:MUTED,margin:0,fontSize:12}}>📱 {s.telefono}</p>
                  <p style={{color:MUTED2,margin:0,fontSize:10}}>{s.rifaNombre}</p>
                </div>
                <div style={{textAlign:"right"}}>
                  <p style={{color:GOLD,margin:0,fontWeight:"bold",fontSize:16}}>{s.cantidad} boletos</p>
                  <p style={{color:GREEN,margin:0,fontSize:12,fontWeight:"bold"}}>RD$ {(s.total||0).toLocaleString()}</p>
                  <p style={{color:MUTED2,margin:0,fontSize:10}}>{s.creadoEn}</p>
                </div>
              </div>
              {s.comprobanteURL&&<img src={s.comprobanteURL} alt="comprobante" style={{width:"100%",borderRadius:10,marginBottom:10,maxHeight:200,objectFit:"cover",border:`1px solid ${BORDER}`}}/>}
              <div style={{background:DARK2,borderRadius:8,padding:"8px 10px",marginBottom:10}}>
                <p style={{color:MUTED,fontSize:10,margin:0}}>⚠️ Al confirmar se asignan <strong style={{color:WHITE}}>{s.cantidad}</strong> números y se notifica al cliente por WhatsApp.</p>
              </div>
              <div style={{display:"flex",gap:6}}>
                <button onClick={()=>confirmar(s)} style={{flex:1,padding:"10px",background:"linear-gradient(135deg,#16a34a,#15803d)",border:"none",borderRadius:10,color:WHITE,fontWeight:"bold",cursor:"pointer",fontSize:12,fontFamily:"inherit"}}>✓ Confirmar y notificar</button>
                <button onClick={()=>rechazarFraude(s)} style={{padding:"10px 12px",background:`${RED}22`,border:`1px solid ${RED}`,borderRadius:10,color:RED,cursor:"pointer",fontSize:12,fontFamily:"inherit",fontWeight:"bold"}}>🚫 Fraude</button>
              </div>
            </Card>
          ))
        }

        {/* Boletos confirmados con opción de cancelar */}
        {boletosConfirmados.length>0&&<>
          <div style={{background:`${GOLD}18`,border:`1px solid ${GOLD}44`,borderRadius:10,padding:"10px 14px",margin:"16px 0 10px"}}>
            <p style={{color:GOLD,margin:0,fontSize:12,fontWeight:"bold"}}>✅ Boletos confirmados — cancelar si el pago no cayó</p>
          </div>
          {boletosConfirmados.map((b)=>{
            const key=b.id;
            return(
              <Card key={key} style={{padding:"12px 16px",position:"relative"}}>
                {/* X pequeña en esquina */}
                {codigoEliminar[key]===undefined&&(
                  <button onClick={()=>setCodigoEliminar(p=>({...p,[key]:""}))}
                    style={{position:"absolute",top:8,right:8,width:20,height:20,borderRadius:"50%",background:`${RED}22`,border:`1px solid ${RED}44`,color:RED,cursor:"pointer",fontSize:10,fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",padding:0}}>
                    ✕
                  </button>
                )}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div>
                    <p style={{color:WHITE,margin:0,fontWeight:"bold",fontSize:13}}>{b.comprador}</p>
                    <p style={{color:MUTED,margin:0,fontSize:11}}>📱 {b.telefono}</p>
                    <div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:4}}>
                      {b.numeros?.map(n=><span key={n} style={{color:GOLD,fontFamily:"monospace",fontSize:10,background:`${GOLD}15`,borderRadius:4,padding:"2px 6px"}}>{n}</span>)}
                    </div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <p style={{color:GREEN,margin:0,fontSize:11,fontWeight:"bold"}}>{b.rifaNombre}</p>
                    <p style={{color:MUTED2,margin:0,fontSize:10}}>RD$ {(b.total||0).toLocaleString()}</p>
                  </div>
                </div>
                {codigoEliminar[key]!==undefined?(
                  <div style={{display:"flex",gap:6,marginTop:8}}>
                    <input placeholder={`Código: ${CODIGO_ELIMINAR}`} value={codigoEliminar[key]} onChange={e=>setCodigoEliminar(p=>({...p,[key]:e.target.value}))}
                      style={{flex:1,background:DARK2,border:`1px solid ${RED}55`,borderRadius:8,padding:"8px 10px",color:WHITE,fontSize:12,outline:"none",fontFamily:"inherit"}}/>
                    <button onClick={async()=>{
                      if(codigoEliminar[key]===CODIGO_ELIMINAR){
                        await rechazarPagoNoCaido(b);
                        setCodigoEliminar(p=>{const n={...p};delete n[key];return n;});
                      }else{alert("Código incorrecto ❌");}
                    }} style={{padding:"8px 12px",background:`${RED}22`,border:`1px solid ${RED}`,borderRadius:8,color:RED,cursor:"pointer",fontSize:12,fontFamily:"inherit",fontWeight:"bold"}}>Cancelar</button>
                    <button onClick={()=>setCodigoEliminar(p=>{const n={...p};delete n[key];return n;})} style={{padding:"8px 10px",background:DARK4,border:`1px solid ${BORDER}`,borderRadius:8,color:MUTED,cursor:"pointer",fontSize:12,fontFamily:"inherit"}}>✕</button>
                  </div>
                ):null}
              </Card>
            );
          })}
        </>}
      </>}

      {/* SORTEO */}
      {seccion==="sorteo"&&<AdminSorteo boletosConfirmados={boletosConfirmados} rifas={rifas}/>}

      {/* RIFAS */}
      {seccion==="rifas"&&<>
        {rifas.map(r=>(
          <Card key={r.id}>
            {rifaEditando===r.id?<>
              <Inp label="Nombre del sorteo" value={rifaLocal.nombre||r.nombre} onChange={e=>setRifaLocal(p=>({...p,nombre:e.target.value}))}/>
              <Inp label="Premio" placeholder="Ej. iPhone 15, Nevera Samsung..." value={rifaLocal.premio||r.premio} onChange={e=>setRifaLocal(p=>({...p,premio:e.target.value}))}/>
              <Inp label="URL de imagen (Google Drive)" placeholder="https://drive.google.com/..." value={rifaLocal.imagen||r.imagen||""} onChange={e=>{const v=e.target.value.trim();const m=v.match(/\/(?:file\/)?d\/([\w-]{20,})/)||v.match(/[?&]id=([\w-]{20,})/);setRifaLocal(p=>({...p,imagen:m?`https://drive.google.com/thumbnail?id=${m[1]}&sz=w2000`:v}));}}/>
              <div style={{display:"flex",gap:8}}>
                <div style={{flex:1}}><Inp label="Precio (RD$)" type="number" value={rifaLocal.precio||r.precio} onChange={e=>setRifaLocal(p=>({...p,precio:Number(e.target.value)}))}/></div>
                <div style={{flex:1}}><Inp label="Mín. boletos" type="number" value={rifaLocal.minBoletos||r.minBoletos} onChange={e=>setRifaLocal(p=>({...p,minBoletos:Number(e.target.value)}))}/></div>
              </div>

              <label style={{display:"block",fontSize:10,color:GOLD,marginBottom:5,letterSpacing:1,textTransform:"uppercase"}}>Dígitos del boleto</label>
              <div style={{display:"flex",gap:6,marginBottom:10}}>
                {[3,4,5].map(d=>{
                  const digitosActual=rifaLocal.digitos!==undefined?rifaLocal.digitos:(r.digitos||4);
                  return(
                    <button key={d} onClick={()=>setRifaLocal(p=>({...p,digitos:d,loteria:LOTERIAS_POR_DIGITOS[d][0].id}))}
                      style={{flex:1,padding:"8px 0",borderRadius:10,fontSize:12,fontWeight:"bold",cursor:"pointer",fontFamily:"inherit",
                        background:digitosActual===d?`linear-gradient(135deg,${GOLD},${GOLD2})`:DARK4,
                        border:`1px solid ${digitosActual===d?GOLD:BORDER}`,color:digitosActual===d?DARK:MUTED2}}>
                      {d} dígitos
                    </button>
                  );
                })}
              </div>

              <label style={{display:"block",fontSize:10,color:GOLD,marginBottom:5,letterSpacing:1,textTransform:"uppercase"}}>Lotería de referencia</label>
              <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:6}}>
                {LOTERIAS_POR_DIGITOS[rifaLocal.digitos!==undefined?rifaLocal.digitos:(r.digitos||4)].map(op=>{
                  const loteriaActual=rifaLocal.loteria!==undefined?rifaLocal.loteria:(r.loteria||LOTERIAS_POR_DIGITOS[r.digitos||4][0].id);
                  return(
                    <button key={op.id} onClick={()=>setRifaLocal(p=>({...p,loteria:op.id}))}
                      style={{padding:"9px 12px",borderRadius:10,fontSize:12,cursor:"pointer",fontFamily:"inherit",textAlign:"left",
                        background:loteriaActual===op.id?`${GOLD}22`:DARK4,
                        border:`1px solid ${loteriaActual===op.id?GOLD:BORDER}`,color:loteriaActual===op.id?GOLD:MUTED2}}>
                      <strong>{op.label}</strong> — {op.horario}
                    </button>
                  );
                })}
              </div>
              <label style={{display:"block",fontSize:10,color:GOLD,marginBottom:5,letterSpacing:1,textTransform:"uppercase"}}>Bases de este sorteo</label>
              <p style={{color:MUTED2,fontSize:10,margin:"0 0 6px",lineHeight:1.5}}>Se guardan junto con este sorteo — si lo borras, sus bases se borran con él. No se acumulan.</p>
              <textarea
                value={rifaLocal.bases!==undefined?rifaLocal.bases:(r.bases||BASES_DEFAULT)}
                onChange={e=>setRifaLocal(p=>({...p,bases:e.target.value}))}
                rows={8}
                style={{width:"100%",background:DARK2,border:`1px solid ${GOLD}44`,borderRadius:10,padding:"11px 13px",color:WHITE,fontSize:12,boxSizing:"border-box",outline:"none",fontFamily:"inherit",lineHeight:1.6,resize:"vertical",marginBottom:12}}
              />

              <div style={{display:"flex",gap:6,marginTop:6}}>
                <button onClick={async()=>{await updateRifa(r.id,rifaLocal);setRifaEditando(null);setRifaLocal({});}} style={{flex:1,padding:"10px",background:`linear-gradient(135deg,${GOLD},${GOLD2})`,border:"none",borderRadius:10,color:DARK,fontWeight:"bold",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>✓ Guardar</button>
                <button onClick={()=>{setRifaEditando(null);setRifaLocal({});}} style={{padding:"10px 14px",background:DARK4,border:`1px solid ${BORDER}`,borderRadius:10,color:MUTED,cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>Cancelar</button>
              </div>
            </>:<>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div>
                  <p style={{color:WHITE,margin:0,fontWeight:"bold",fontSize:13}}>{r.nombre}</p>
                  <p style={{color:GOLD,margin:"2px 0",fontSize:11}}>🏆 {r.premio||"Sin premio definido"}</p>
                  <p style={{color:MUTED,margin:0,fontSize:10}}>RD$ {r.precio} · mín. {r.minBoletos} · {Array(r.digitos||4).fill("0").join("")}-{Array(r.digitos||4).fill("9").join("")} · {loteriaDeRifa(r).label}</p>
                  <p style={{color:GREEN,margin:"2px 0 0",fontSize:10}}>✅ {boletosConfirmados.filter(b=>b.rifaId===r.id).length} vendidos · ⏳ {solicitudes.filter(s=>s.rifaId===r.id).length} pendientes</p>
                </div>
                <div style={{display:"flex",gap:6,flexShrink:0}}>
                  <button onClick={()=>{setRifaEditando(r.id);setRifaLocal({});}} style={{background:`${GOLD}22`,border:`1px solid ${GOLD}55`,borderRadius:8,padding:"5px 10px",color:GOLD,cursor:"pointer",fontSize:11,fontFamily:"inherit"}}>✏️ Editar</button>
                  {boletosConfirmados.filter(b=>b.rifaId===r.id).length===0&&(
                    <button onClick={async()=>{
                      const pendientesDeEsta=solicitudes.filter(s=>s.rifaId===r.id);
                      const msg=pendientesDeEsta.length>0
                        ?`⚠️ ¿Seguro que quieres ELIMINAR el sorteo "${r.nombre}"?\n\nTiene ${pendientesDeEsta.length} solicitud(es) pendiente(s) sin confirmar — también se eliminarán.\n\nEsta acción no se puede deshacer.`
                        :`⚠️ ¿Seguro que quieres ELIMINAR el sorteo "${r.nombre}"?\n\nEsta acción no se puede deshacer.`;
                      if(!window.confirm(msg))return;
                      await Promise.all(pendientesDeEsta.map(s=>deleteDoc(doc(db,"solicitudes",s.id))));
                      await deleteDoc(doc(db,"rifas",r.id));
                    }} style={{background:`${RED}18`,border:`1px solid ${RED}55`,borderRadius:8,padding:"5px 10px",color:RED,cursor:"pointer",fontSize:11,fontFamily:"inherit"}}>🗑️</button>
                  )}
                </div>
              </div>
            </>}
          </Card>
        ))}
        <button onClick={async()=>{const r=RIFA_DEFAULT();await setDoc(doc(db,"rifas",r.id),r);}} style={{width:"100%",padding:"11px",background:`${GOLD}12`,border:`2px dashed ${GOLD}44`,borderRadius:12,color:GOLD,fontSize:13,cursor:"pointer",fontFamily:"inherit",marginTop:2}}>
          + Agregar nueva rifa
        </button>
      </>}

      {/* RANKING */}
      {seccion==="ranking"&&<>
        <Card style={{textAlign:"center",padding:"14px"}}>
          <p style={{margin:0,color:GOLD,fontSize:13,fontWeight:"bold"}}>🏅 Top 3 Compradores</p>
          <p style={{margin:"4px 0 0",color:MUTED,fontSize:11}}>En caso de empate gana quien compró primero</p>
        </Card>
        {ranking.length===0
          ?<Card><p style={{color:MUTED2,textAlign:"center",margin:0}}>Aún no hay boletos confirmados.</p></Card>
          :ranking.slice(0,3).map((p,i)=>(
            <Card key={p.telefono} style={{padding:"12px 16px",border:`1px solid ${i===0?GOLD:i===1?"#94a3b8":"#cd7c2f"}44`}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:40,height:40,borderRadius:"50%",background:i===0?`linear-gradient(135deg,${GOLD},${GOLD2})`:i===1?`linear-gradient(135deg,#94a3b8,#cbd5e1)`:`linear-gradient(135deg,#cd7c2f,#b45309)`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:"bold",fontSize:20,flexShrink:0}}>
                  {i===0?"🥇":i===1?"🥈":"🥉"}
                </div>
                <div style={{flex:1}}>
                  <p style={{color:WHITE,margin:0,fontWeight:"bold",fontSize:14}}>{p.nombre}</p>
                  <p style={{color:MUTED,margin:0,fontSize:11}}>📱 {p.telefono}</p>
                  <p style={{color:MUTED2,margin:0,fontSize:10}}>Desde: {p.primerCompra}</p>
                </div>
                <div style={{textAlign:"right"}}>
                  <p style={{color:GOLD,margin:0,fontWeight:"bold",fontSize:20}}>{p.boletos}</p>
                  <p style={{color:MUTED2,margin:0,fontSize:9}}>boletos</p>
                  <p style={{color:GREEN,margin:0,fontSize:11}}>RD$ {p.gasto.toLocaleString()}</p>
                </div>
              </div>
            </Card>
          ))
        }
        {ranking.length>3&&(()=>{
          const empatados=ranking.slice(3).filter(p=>p.boletos===ranking[2].boletos);
          if(empatados.length===0)return null;
          return(
            <div>
              <button onClick={()=>setVerMas(!verMas)} style={{width:"100%",padding:"10px",background:DARK3,border:`1px solid ${GOLD}44`,borderRadius:12,color:GOLD,cursor:"pointer",fontSize:12,fontFamily:"inherit",marginTop:4}}>
                {verMas?"▲ Ocultar":"▼"} {empatados.length} participante{empatados.length>1?"s":""} empatado{empatados.length>1?"s":""} con 🥉
              </button>
              {verMas&&<>
                <div style={{background:DARK2,border:`1px solid ${GOLD}33`,borderRadius:10,padding:"10px 12px",margin:"8px 0 6px"}}>
                  <p style={{color:MUTED,fontSize:11,margin:0}}>⚠️ Estos participantes tienen la misma cantidad de boletos que 🥉 pero compraron después. Si compran <strong style={{color:GOLD}}>1 boleto más</strong> suben al podio.</p>
                </div>
                {empatados.map((p)=>(
                  <Card key={p.telefono} style={{padding:"10px 14px",marginTop:6,border:`1px solid ${GOLD}33`}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <div style={{width:32,height:32,borderRadius:"50%",background:`${GOLD}22`,border:`1px solid ${GOLD}55`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}>
                        🎟️
                      </div>
                      <div style={{flex:1}}>
                        <p style={{color:WHITE,margin:0,fontSize:12,fontWeight:"bold"}}>{p.nombre}</p>
                        <p style={{color:MUTED,margin:0,fontSize:10}}>📱 {p.telefono}</p>
                        <p style={{color:MUTED2,margin:"2px 0 0",fontSize:9}}>🗓️ Compró el: {p.primerCompra?.slice(0,16).replace("T"," ")||"—"}</p>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <p style={{color:GOLD,margin:0,fontWeight:"bold",fontSize:15}}>{p.boletos}</p>
                        <p style={{color:MUTED2,margin:0,fontSize:9}}>boletos</p>
                        <p style={{color:GREEN,margin:"2px 0 0",fontSize:9}}>+1 para subir al podio</p>
                      </div>
                    </div>
                  </Card>
                ))}
              </>}
            </div>
          );
        })()}
      </>}

      {/* CUENTAS */}
      {seccion==="cuentas"&&(
        <Card>
          <h4 style={{color:GOLD,fontSize:11,margin:"0 0 10px",letterSpacing:1,textTransform:"uppercase"}}>💳 Cuentas activas</h4>
          {cuentas.map((c,i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:`1px solid ${BORDER}`}}>
              <div>
                <p style={{color:WHITE,margin:0,fontSize:12,fontWeight:"bold"}}>{c.icon} {c.banco}</p>
                <p style={{color:GOLD,margin:0,fontSize:10,fontFamily:"monospace"}}>{c.cuenta}</p>
                <p style={{color:MUTED2,margin:0,fontSize:10}}>A nombre de: {c.titular||TITULAR}</p>
              </div>
              <button onClick={()=>quitarCuenta(i)} style={{background:`${RED}20`,border:`1px solid ${RED}`,color:RED,borderRadius:8,padding:"4px 10px",cursor:"pointer",fontSize:11,fontFamily:"inherit"}}>Quitar</button>
            </div>
          ))}
          <GDiv/>
          <Inp label="Nombre del banco" placeholder="Ej. Scotiabank" value={nuevoBanco} onChange={e=>setNuevoBanco(e.target.value)}/>
          <Inp label="Número / correo" placeholder="Ej. 123456789" value={nuevaCuenta} onChange={e=>setNuevaCuenta(e.target.value)}/>
          <Inp label="A nombre de (titular)" placeholder="Ej. Mia San Juan" value={nuevoTitular} onChange={e=>setNuevoTitular(e.target.value)}/>
          <button onClick={agregarCuenta} disabled={!nuevoBanco||!nuevaCuenta} style={{width:"100%",padding:"10px",background:nuevoBanco&&nuevaCuenta?`${GOLD}22`:DARK4,border:`1px solid ${nuevoBanco&&nuevaCuenta?GOLD:BORDER}`,borderRadius:10,color:nuevoBanco&&nuevaCuenta?GOLD:MUTED2,cursor:nuevoBanco&&nuevaCuenta?"pointer":"not-allowed",fontSize:13,fontFamily:"inherit",marginTop:4}}>
            + Agregar cuenta
          </button>
        </Card>
      )}

      {/* CONFIG */}
      {seccion==="config"&&<>
        <Card>
          <h4 style={{color:GOLD,fontSize:11,margin:"0 0 4px",letterSpacing:1,textTransform:"uppercase"}}>🔧 Modo mantenimiento</h4>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 12px",lineHeight:1.6}}>Cuando está activo, la página pública muestra solo una pantalla negra de "en mantenimiento" — nadie ve ningún sorteo ni puede comprar. El panel de admin sigue funcionando normal para que puedas desactivarlo.</p>
          <button onClick={()=>toggleConfigGeneral("mantenimiento")} style={{width:"100%",padding:"12px",borderRadius:10,border:`1px solid ${configGeneral.mantenimiento?RED:GREEN}`,background:configGeneral.mantenimiento?`${RED}22`:`${GREEN}18`,color:configGeneral.mantenimiento?RED:GREEN,fontWeight:"bold",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>
            {configGeneral.mantenimiento?"🔴 Mantenimiento ACTIVADO — tocar para desactivar":"🟢 Página pública funcionando — tocar para activar mantenimiento"}
          </button>
        </Card>
        <Card>
          <h4 style={{color:GOLD,fontSize:11,margin:"0 0 4px",letterSpacing:1,textTransform:"uppercase"}}>🏷️ Código de referido</h4>
          <p style={{color:MUTED,fontSize:11,margin:"0 0 12px",lineHeight:1.6}}>Muestra un campo opcional en el formulario de compra para que el cliente escriba el código de quien lo ayudó a comprar. Se guarda en cada boleto y sale como columna en el Excel exportado.</p>
          <button onClick={()=>toggleConfigGeneral("mostrarReferido")} style={{width:"100%",padding:"12px",borderRadius:10,border:`1px solid ${configGeneral.mostrarReferido?GOLD:BORDER}`,background:configGeneral.mostrarReferido?`${GOLD}22`:DARK4,color:configGeneral.mostrarReferido?GOLD:MUTED,fontWeight:"bold",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>
            {configGeneral.mostrarReferido?"✅ Campo de referido VISIBLE — tocar para ocultar":"➕ Campo de referido oculto — tocar para mostrar"}
          </button>
        </Card>
      </>}
    </div>
  );
}
